if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      updateBuildBoxStatus() {
        const subscriptionMain = document.querySelector('.custom-subscription-main');
        const addToCartBtn = document.getElementById('build-box-addtocart');
        const allBoxItems = document.querySelectorAll('.box-item');
        const hasItems = Array.from(allBoxItems).some(item => !item.classList.contains('empty'));
      
        if (addToCartBtn) {
          addToCartBtn.disabled = !hasItems;
          addToCartBtn.setAttribute('aria-disabled', !hasItems);
        }
        // ✅ Toggle `empty-state` class on the wrapper
        if (subscriptionMain) {
          if (!hasItems) {
            subscriptionMain.classList.add('empty-state');
          } else {
            subscriptionMain.classList.remove('empty-state');
          }
        }
      }
      updateBundlePricing() {
        const discountRate = 0.10;
        let totalOriginalPriceCents = 0;
      
        document.querySelectorAll('.box-item:not(.empty)').forEach(item => {
          const priceStr = item.getAttribute('data-variant-price');
          if (priceStr && !isNaN(priceStr)) {
            const priceCents = parseFloat(priceStr) * 100;
            totalOriginalPriceCents += priceCents;
          }
        });
      
        const discountedPriceCents = totalOriginalPriceCents * (1 - discountRate);
      
        const formatMoney = (cents) => `$${(cents / 100).toFixed(2)}`;
      
        const priceOnlyElement = document.querySelector('.subscribe-and-save .price-only');
        if (priceOnlyElement) {
          priceOnlyElement.innerHTML = `
            <del>${formatMoney(totalOriginalPriceCents)}</del>
            <span class="final-price">${formatMoney(discountedPriceCents)}</span>
          `;
        }
      }
      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const productElement = responseHTML.querySelector('product-info');
      
          this.preprocessHTML(productElement);
          HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
          
          const productFormButtons = this.modalContent.querySelector('.product-form__buttons');
          let SUBSCRIPTION_BOX_LIMIT = 4;
          if (productFormButtons) {
            const customAnchor = document.createElement('a');
            customAnchor.href = '#';
            customAnchor.className = 'add-to-subscription-box button';
            customAnchor.textContent = 'Add to Subscription Box';
            productFormButtons.insertAdjacentElement('afterend', customAnchor);
          
            const errorMsg = document.createElement('div');
            errorMsg.className = 'subscription-box-error';
            errorMsg.style.display = 'none';
            errorMsg.textContent = `Only ${SUBSCRIPTION_BOX_LIMIT} items allowed in the box.`;
            customAnchor.insertAdjacentElement('afterend', errorMsg);
          
            customAnchor.addEventListener('click', (e) => {
              e.preventDefault();
            
              const modal = customAnchor.closest('quick-add-modal');
              if (!modal) return;

              const selectedVariantId = modal.getAttribute('data-selected-variant') || '';
              const productImage = modal.getAttribute('data-product-image') || '';
              const selectedVariantTitle = modal.getAttribute('data-selected-variant-title') || '';
              const selectedVariantPrice = modal.getAttribute('data-selected-variant-price') || ''; // in dollars, e.g. "34.99"
            
              const boxItems = document.querySelectorAll('.box-item.empty');
              const nonEmptyItems = document.querySelectorAll('.box-item:not(.empty)');
            
              if (nonEmptyItems.length >= SUBSCRIPTION_BOX_LIMIT) {
                errorMsg.style.display = 'block';
                return;
              } else {
                errorMsg.style.display = 'none';
              }
            
              if (boxItems.length > 0) {
                const firstEmpty = boxItems[0];
            
                firstEmpty.classList.remove('empty');
                firstEmpty.setAttribute('data-variant-id', selectedVariantId);
                firstEmpty.setAttribute('data-variant-price', selectedVariantPrice); // Store price in dollars for calculation
            
                firstEmpty.querySelector('.box-item-inner').innerHTML = `
                  <div class="image-box"><img src="${productImage}" alt=""></div>
                  <div class="product-info">${selectedVariantTitle}</div>
                  <div class="remove-btn">Remove</div>
                `;
            
                const removeBtn = firstEmpty.querySelector('.remove-btn');
                if (removeBtn) {
                  removeBtn.addEventListener('click', () => {
                    firstEmpty.classList.add('empty');
                    firstEmpty.removeAttribute('data-variant-id');
                    firstEmpty.removeAttribute('data-variant-price');
                    firstEmpty.querySelector('.box-item-inner').innerHTML = '<div class="image-box"></div>';
            
                    this.updateBundlePricing(); // recalculate prices after removal
                    this.updateBuildBoxStatus();
            
                    const stillOverLimit = document.querySelectorAll('.box-item:not(.empty)').length >= SUBSCRIPTION_BOX_LIMIT;
                    if (!stillOverLimit) {
                      errorMsg.style.display = 'none';
                    }
                  });
                }
            
                modal.hide();
                this.updateBuildBoxStatus();
                this.updateBundlePricing(); // calculate prices after addition
                const targetSection = document.querySelector('#custom-subscription-main');
                if (targetSection) {
                  setTimeout(() => {
                    targetSection.scrollIntoView({ behavior: 'smooth' });
                  }, 300);
                }
              }
            });
          }
      
          const variantInput = this.modalContent.querySelector('input[name="id"]');
      
          /*if (variantInput) {
            // Define a function to update offer and trigger sub button
            const updateOfferAndTriggerSub = () => {
              const variantId = variantInput.value;
              const productUrl = opener?.getAttribute('data-product-url') || '';
              const productHandle = productUrl.split('/products/')[1]?.split('?')[0] || '';
      
              const offerMountPoint = this.modalContent.querySelector('.product__info-container');
              if (offerMountPoint) {
                let offer = offerMountPoint.querySelector('og-offer');
                let subbutton = offerMountPoint.querySelector('og-subscription-button');
                if (offer) {
                  offer.setAttribute('product', variantId);
                  offer.setAttribute('data-shopify-product-handle', productHandle);
                  offer.setAttribute('location', 'quick-add');
                  // offer.setAttribute('frequency', universalSelect.value);
                  // subbutton.setAttribute('frequency', universalSelect.value);
                }
              }
      
              requestAnimationFrame(() => {
                const subBtn = this.modalContent.querySelector('og-subscription-button');
                if (subBtn) subBtn.click();
              });
            };
      
            // Run once on initialization if there's a value
            if (variantInput.value) {
              updateOfferAndTriggerSub();
            }
      
            // Add event listener to update on variant changes
            variantInput.addEventListener('change', updateOfferAndTriggerSub);
          }*/
      
          // End custom universal frequency select code
      
          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) window.ProductModel.loadShopifyXR();
      
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading__spinner').classList.add('hidden');
        });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
